import { Button, Space } from 'antd';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { type LabelsModuleSpecsFragment } from '../../../../api/fragments/LabelsModuleSpecs';
import DrawerWithAutoWidth from '../../../../components/DrawerWithAutoWidth';
import LabelsModuleUpdateForm from './LabelsModuleUpdateForm';

export type LabelsModuleUpdateDrawerProps = {
    module: LabelsModuleSpecsFragment;
    onClose: () => void;
    visible: boolean;
};

const LabelsModuleUpdateDrawer = ({ module, onClose, visible }: LabelsModuleUpdateDrawerProps) => {
    const { t } = useTranslation(['labelsModule']);

    return (
        <DrawerWithAutoWidth
            extra={
                <Space>
                    <Button onClick={onClose}>{t('labelsModule:updateDrawer.cancelButton')}</Button>
                    <Button form="updatelabelsModule" htmlType="submit" type="primary">
                        {t('labelsModule:updateDrawer.submitButton')}
                    </Button>
                </Space>
            }
            onClose={onClose}
            title={t('labelsModule:updateDrawer.title')}
            visible={visible}
            destroyOnClose
        >
            <LabelsModuleUpdateForm module={module} onComplete={onClose} />
        </DrawerWithAutoWidth>
    );
};

export default LabelsModuleUpdateDrawer;

export const useUpdateLabelsModuleDrawer = (module: LabelsModuleUpdateDrawerProps['module']) => {
    const [visible, setVisible] = useState(false);

    const actions = useMemo(
        () => ({
            open: () => setVisible(true),
            close: () => setVisible(false),
        }),
        [setVisible]
    );

    return {
        ...actions,
        render: () => <LabelsModuleUpdateDrawer module={module} onClose={actions.close} visible={visible} />,
    };
};
